// extracted by mini-css-extract-plugin
export default {"wrap":"catalog_wrap__DM6zw","titleText":"catalog_titleText__jGNUT","header_title":"catalog_header_title__8aYh8"};